import { useEffect, useMemo, useState } from "react";

export function useProcessedItems(rawItems, processItemsFn) {
  const [searchValue, setSearchValue] = useState("");

  const processedItems = useMemo(() => {
    if (!processItemsFn) return rawItems;
    return processItemsFn(rawItems, searchValue.toLowerCase());
  }, [rawItems, searchValue, processItemsFn]);

  useEffect(() => {
    setSearchValue("");
  }, [rawItems]);

  return { processedItems, searchValue, setSearchValue };
}
